import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取城市列表
export const getCityeList = params => {
    return get("/admin/citys", params);
};
// 新增城市
export const addCity = params => {
    return post("/admin/citys", params);
};
// 修改城市信息
export const editCity = params => {
    return put(`/admin/citys/${params.id}`, params);
};
// 删除城市
export const deleteCity = params => {
    return del(`/admin/citys/${params}`);
};
// 生成授权码
export const getCode = params => {
    return post("/admin/companys/createSecretCode", params);
};


// WEBPACK FOOTER //
// ./src/api/city.js